// extracted by mini-css-extract-plugin
export default {"mediaQueryMobile":"810","mediaQueryTablet":"1024","mediaQueryDesktop":"1440","title":"title__title___INhx5","large":"title__large___kP6Lb"};